import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '../global';

export interface VinculadorPagadorPmResponse {
  message: string;
  status: string;
}

@Injectable({
  providedIn: 'root'
})
export class VinculadorPagadorPmService {
  private readonly API_URL: string;

  constructor(private readonly http: HttpClient) {
    this.API_URL = Global.url + '/vinculacion/pagador';
  }

  uploadDocuments(camaraComercio: File, estadosFinancieros: File, email: string): Observable<VinculadorPagadorPmResponse> {
    const formData = new FormData();
    formData.append('camara_comercio', camaraComercio, camaraComercio.name);
    formData.append('estados_financieros', estadosFinancieros, estadosFinancieros.name);
    formData.append('email', email);

    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    });

    return this.http.post<VinculadorPagadorPmResponse>(this.API_URL, formData, { headers });
  }
}
